<template>
  <div>
    <v-row style="background-color: #EEEEEE;" align="center">
      <v-col style="    max-width: fit-content">
        <v-icon right @click="changePage">mdi-arrow-left</v-icon>
      </v-col>
      <v-col style="    max-width: fit-content">
        <h4
          style="margin-left: 0px;font-size:28px; color:#777; font-weight:300; text-align:left; min-inline-size: max-content;"
        >{{editedQueue.name}}</h4>
      </v-col>
      <v-col offset-xs="3" offset-sm="7" offset-md="7">
        <v-btn icon color="admiraFontGray" class="py-0 my-0">
          <v-icon style="cursor: pointer; font-size:25px" @click="editQueue(editedQueue)">mdi-pencil</v-icon>
        </v-btn>

        <!--Begin dialog delete-->

        <v-dialog width="500" v-model="deleteDialog">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon color="admiraFontGray" class="py-0 my-0">
              <v-icon style="cursor: pointer; font-size:25px">mdi-delete</v-icon>
            </v-btn>
          </template>

          <v-card class="pl-5 pr-5">
            <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
            <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
              <p>
                ¿Estás seguro que quieres eliminar este elemento?
                <br />Esta acción no se puede deshacer
              </p>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-col cols="6">
                  <v-btn
                    style="border-color: #fff;"
                    @click="deleteDialog = false"
                    rounded
                    depressed
                    outlined
                    small
                    width="100"
                  >Cancelar</v-btn>
                </v-col>

                <v-col cols="6">
                  <v-btn
                    @click="deleteQueue({idQueue: editedQueue.idQueue})"
                    style="background: #679940;"
                    dark
                    rounded
                    depressed
                    outlined
                    small
                    width="100"
                  >Aceptar</v-btn>
                </v-col>
              </v-card-actions>
            </v-col>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row style="    margin-top: -1px;">
      <v-col style="padding-top:0px;">
      <v-tabs class="tabs" centered grow height="45px" v-model="activeTab">
        <v-tab style="background-color: #EEEEEE;">Directo</v-tab>
        <v-tab style="background-color: #EEEEEE;">Stands</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">

        <v-tab-item >
          <!--Begin tab Directo-->
          <v-container
            class
            fluid
            style="padding-top: 0px; padding-bottom: 0px;"
          >
            <v-col cols="12">
              <v-row>
                <v-col v-if="editedQueue.type == 3">
                  <v-col style="background-color:#EEEEEE;border-radius:15px">
                    <p
                      style="text-align: left; margin-left: 25px; font-size: 21px;color:#777; font-weight:300;    margin-bottom: 0px;"
                      v-if="editedQueue.type == 3"
                    >Fila Multipuesto con Tiquets</p>
                    <br />
                    <div style="display:flex;margin-left: 5px;">
                      <div style="display:inline;">
                        <v-icon style="font-size:55px;">mdi-ticket-confirmation</v-icon>
                      </div>
                      <div>
                        <p
                          style="text-align: left; margin-left: 5px; font-size: 15px; color:#777; font-weight:300;"
                        >Sistema de turnos para gestionar variospuestos con diversas cajas por puesto con impresión de tickets.</p>
                      </div>
                    </div>
                  </v-col>
                </v-col>

                <v-col v-if="editedQueue.type == 2">
                  <v-col style="background-color:#EEEEEE;border-radius:15px">
                    <p
                      style="text-align: left; margin-left: 5px; font-size: 21px; color:#777; font-weight:300;    margin-bottom: 0px;"
                    >Fila Única con Tiquets</p>
                    <br />
                    <div style="display:flex;margin-left: 5px;">
                      <div>
                        <v-icon style="font-size:55px">mdi-ticket-outline</v-icon>
                      </div>
                      <p
                        style="text-align: left; margin-left: 25px; font-size: 15px; color:#777; font-weight:300;    margin-bottom: 0px;"
                      >Sistema de fila única con impresión de tickets.</p>
                    </div>
                  </v-col>
                </v-col>

                <v-col v-if="editedQueue.type == 1">
                  <v-col style="background-color:#EEEEEE;border-radius:15px">
                    <p
                      style="text-align: left; margin-left: 5px; font-size: 21px; color:#777; font-weight:300;"
                    >Fila Única</p>
                    <br />
                    <div style="display:flex;margin-left: 5px;">
                      <div>
                        <v-icon style="font-size:55px">mdi-human-male-male</v-icon>
                      </div>
                      <p
                        style="text-align: left; margin-left: 25px; font-size: 15px; color:#777; font-weight:300;"
                      >Sistema de fila individual sin tickets. Conforme los clientes alcanzan el frente, ellos son llamados para el siguiente mostrador disponible cuando el contador presiona un botón.</p>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-row>
                <br />
                <p
                  style="text-align: left; margin-left: 25px; font-size: 21px;margin-top: 15px; color:#777; font-weight:300;"
                >Turnos</p>
              </v-row>
              <v-row style v-for="tiquets in arrTiquets" :key="tiquets.resources">
                <v-col v-if="tiquets.operative === 1">
                  <v-container
                    style="background-color: #eeee; border-radius: 15px;  margin-left: 35px; "
                  >
                    <p
                      style=" color:#acacac; margin-bottom: 0px; font-size: 30px; font-weight: 300; "
                      v-if="tiquets.ticketNow != null"
                    >{{tiquets.ticketNow.ticket}}</p>
                    <p
                      style=" color:#acacac; margin-bottom: 0px; font-size: 30px; font-weight: 300; "
                      v-if="tiquets.ticketNow == null"
                    >--</p>
                  </v-container>
                </v-col>
                <v-col v-if="tiquets.operative === 1">
                  <p
                    style="color:#acacac; margin-bottom: 0px; font-size: 22px; font-weight: 300;padding-top: 15px;"
                    v-if="tiquets.resources != null"
                  >{{tiquets.spaceName}}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-container>
         
        </v-tab-item>

        <v-tab-item  style="background-color: #EEEEEE">
          <v-container
            fluid
            style="background-color: #E0E0E0;padding-top: 0px; padding-bottom: 0px;height: calc(100vh - 165px); overflow: auto"
          >
          <v-row>
              <v-col cols="12">
                <v-row
                  v-for="queues in arrStands"
                  :key="queues.idQueue"
                  @click="viewResource(queues)"
                >
                  <v-col
                    style="background-color: white;margin:3% 3% 3% 3%;border-radius:15px;    display: inline-flex;padding-top: 0px; padding-bottom: 0px"
                  >
                    <v-col
                      style="background-color: #E0E0E0;margin:4% 8% 4% 0%;border-radius:15px;max-width: 75px; "
                    >
                      <v-icon color="#679940">mdi-store</v-icon>
                    </v-col>

                    <v-col>
                      <v-row>
                        <p  style="padding-bottom:0px">{{queues.name}}</p>
                        <br />
                      </v-row>
                      <v-row>
                        <p style="padding-bottom:0px;color:#ACACAC">{{queues.space}}</p>
                      </v-row>
                    </v-col>
        
                    <v-col style="padding-top: 8%;">
                      <v-menu offset-y transition="slide-y-transition" bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon small>
                            <v-icon dark>mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <!-- <v-list-item @click="infoStand(queues)">
                        <v-list-item-title style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 21px;">mdi-information-variant</v-icon> Detalles</v-list-item-title>
                          </v-list-item>-->
                          <v-list-item @click="viewResource(queues)">
                            <v-list-item-title style="font-size:12px; color:#9e9e9e">
                              <v-icon style="font-size: 19px;">mdi-play-circle</v-icon>Turnos
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-dialog width="500" v-model="deleteDialog">
                              <template v-slot:activator="{ on }">
                                <v-list-item-title
                                  v-on="on"
                                  style="cursor:pointer; font-size:12px; color:#9e9e9e"
                                >
                                  <v-icon style="font-size: 19px;">mdi-close-circle-outline</v-icon>Quitar
                                </v-list-item-title>
                              </template>
                              <v-card class="pl-5 pr-5">
                                <v-card-title
                                  style="color: #679940; padding-left:12px;"
                                >Eliminar soporte</v-card-title>
                                <v-col
                                  justify-center
                                  cols="12"
                                  class="mt-5 pb-5"
                                  style="margin-top:-30px"
                                >
                                  <p>
                                    ¿Estás seguro que quieres eliminar este elemento?
                                    <br />Esta acción no se puede deshacer
                                  </p>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-col cols="6">
                                      <v-btn
                                        style="border-color: #fff;"
                                        @click="deleteDialog = false"
                                        rounded
                                        depressed
                                        outlined
                                        small
                                        width="100"
                                      >Cancelar</v-btn>
                                    </v-col>

                                    <v-col cols="6">
                                      <v-btn
                                        @click="quitStand(queues)"
                                        style="background: #679940;"
                                        dark
                                        rounded
                                        depressed
                                        outlined
                                        small
                                        width="100"
                                      >Aceptar</v-btn>
                                    </v-col>
                                  </v-card-actions>
                                </v-col>
                              </v-card>
                            </v-dialog>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
              </v-col>

     

            <v-btn
              @click="addStand"
              class="mx-2"
              fab
              dark
              medium
              color="#679940"
              style=" position: fixed; left: 75%; top: 88%;"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            </v-row>
          </v-container>
        </v-tab-item>

      </v-tabs-items>
      </v-col>
    </v-row>
  
    <v-navigation-drawer
      hide-overlay
      :disable-route-watcher="true"
      :value="showRightMenu"
      absolute
      :clipped="$vuetify.breakpoint.smAndUp"
      width="419"
      style="height: calc(100vh - 50px);z-index:100"
      class="elevation-4"
      right
      stateless
    >
      <RightMenuEditQueue v-if="RightMenuEditQueue" />
      <RightMenuAddNewStand v-if="RightMenuAddNewStand" />
      <RightMenuStandDetail v-if="RightMenuStandDetail" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import router from "vue-router";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
import RightMenuAddNewStand from "@/components/RightMenuAddNewStand.vue";
import RightMenuStandDetail from "@/components/RightMenuStandDetail.vue";

export default {
  name: "queues",
  components: {
    RightMenuEditQueue,
    RightMenuAddNewStand,
    RightMenuStandDetail
  },
  data: () => ({
    color: "#f5b70e",
    color1: "#f6c231",
    color2: "#FFFFFFFF",
    color3: "#f5b70e",
    color4: "#f6c231",
    color5: "#FFFFFFFF",
    color6: "#f5b70e",
    color7: "#f6c231",
    color8: "#FFFFFFFF",

    selected: [],
    tiquets: this.TicketsBySpace,
    checkbox: true,
    showAlertName: false,
    showAlertWidth: false,
    showAlertHeight: false,
    tabs: [
      { id: 1, name: "DIRECTO", route: "" },
      { id: 2, name: "STANDS", route: "" }
      // { id: 3, name: "CONTENIDO", route: "" }
    ],
    activeTab: null,
    deleteDialog: false
  }),
  computed: {
    arrStands() {
      let stands = this.allResouces;

      let idResources = this.editedQueue.resources;

      if (idResources != undefined) {
        stands = stands.filter(
          stand => idResources.indexOf(stand.idResource) !== -1
        );

        return stands;
      } else {
        stands = [];
        return stands;
      }
    },
    arrTiquets() {
      let tiquets = this.TicketsBySpace;
      const allResouces = this.allResouces;
      let tiquetsFinal = [];
      let idQueue = this.editedQueue.idQueue;

      if (idQueue != undefined) {
        for (let i = 0; i < tiquets.length; i++) {
          if (tiquets[i].queue == idQueue) {
            tiquets[i].operative = allResouces.find(resource => resource.idResource === +tiquets[i].resources).operative || 0
            tiquetsFinal.push(tiquets[i]);
          }
        }

        return tiquetsFinal;
      } else {
        tiquetsFinal = [];
        return tiquetsFinal;
      }
    },
    ...mapState("queues", [
      "TicketsBySpace",
      "objQueueCont",
      "editedQueue",
      "allResouces",
      "showRightMenu",
      "RightMenuEditQueue",
      "RightMenuAddNewStand",
      "RightMenuStandDetail"
    ]),
    headers() {
      return [
        { text: "", value: "icon" },
        { text: "Nombre", value: "name", align: "start" },
        { text: "Sitio", value: "spaceName" },
        { text: "", value: "actions" }
      ];
    }
  },
  methods: {
    ...mapActions("queues", [
      "getTicketBySpace",
      "getTicketStore",
      "editQueueStore",
      "deleteOneQueueStore",
      "showRightMenuProposalStore",
      "rightMenuTrueNewDeviceTableStore",
      "rightMenuTrueNewDeviceTableStore2",
      "rightMenuTrueNewDeviceTableStore3",
      "rightMenuTrueNewDeviceTableStore4",
      "getTicketBySpaceStore",
      "editedQueueStore"
    ]),
    ...mapMutations("queues", [
      "spaceActions",
      "openRightMenuMutation",
      "closeRightMenuMutation"
    ]),

    hideAlertNameCont() {
      if (this.objQueueCont.name != "") {
        this.showAlertName = false;
      }
    },
    hideAlertWidthCont() {
      if (this.objQueueCont.width != "") {
        this.showAlertWidth = false;
      }
    },
    hideAlertHeightCont() {
      if (this.objQueueCont.height != "") {
        this.showAlertHeight = false;
      }
    },

    changePage() {
      this.$router.push({
        name: "QueuesMobile"
      });
      this.closeRightMenuMutation();
    },
    editQueue(data) {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore2(this.editedQueue);
    },
    deleteQueue(data) {
      this.deleteOneQueueStore(data);
      this.$router.go(-1);
      this.closeRightMenuMutation();
    },
    addStand() {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore3();
    },
    quitStand(data) {
      const index = this.editedQueue.resources.indexOf(data.idResource);
      if (index > -1) {
        this.editedQueue.resources.splice(index, 1);
      }
      this.editedQueueStore(this.editedQueue);
      this.deleteDialog = false;
      this.selected = [];
    },
    quitStandMulti(data) {
      console.log("entro multi");
      console.log(data);

      //  const index = this.editedQueue.resources.indexOf(data.idResource);

      // if (index > -1) {
      //   this.editedQueue.resources.splice(index, 1);
      // }
      // this.editedQueueStore(this.editedQueue);
      this.selected = [];
    },
    infoStand(data) {
      (this.RightMenuEditQueue = false),
        (this.RightMenuAddNewStand = false),
        this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore4();
    },

    viewResource(data) {
      this.spaceActions(data);
      this.$router.push({
        name: "QueueStandTurnMobile",
        params: { idSpace: data }
      });
      this.getTicketStore(data.idResource);
    },
    setClock() {
      let element = document.getElementById("hour");

      if (this.checkbox == false) {
        element.style.display = "none";
      } else {
        element.style.display = "";
      }
    }
  },
  async created() {
    this.getTicketBySpace(this.editedQueue.space);
  }
};
</script>

<style scoped>
h5 {
  font-size: 12px;
  font-weight: 300;
  text-align: initial;
}

h3 {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #aeaeae;
}
>>> .v-data-table__wrapper {
  height: calc(100vh - 256px);
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/QueueDetailsMobile.vue